import React, { useState } from "react";
import log from 'loglevel';
import { getSessionFromStorage, SessionContext } from 'components/Session';
import { LogRocketLazyLoader } from "components/LogRocketLazyLoader";
import { loadAdCritterScripts, parseAdvertisingQueryParams } from "../components/AdCritter";


const App = (props) => {
  const { children, browser } = props;
  log.debug("App::render() props:", props);

  const [ sessionContext, setSessionContextState ] = useState(getSessionFromStorage());
  const setSessionContext = (newSessionContext) => {
    localStorage.setItem("sessionContext", JSON.stringify(newSessionContext));
    setSessionContextState(newSessionContext);
  };

  if (browser) {
    // Only load AdCritter scripts in real browser environment
    loadAdCritterScripts();
    parseAdvertisingQueryParams(sessionContext, setSessionContextState);
  }

  return (
    <SessionContext.Provider value={{ sessionContext, setSessionContext }}>
      <LogRocketLazyLoader />
      { children }
    </SessionContext.Provider>
  );
};

export default App;
